module.exports = __webpack_public_path__ + "static/media/orange_pen.a5ecfcc7.svg";